
import Swiper from 'swiper';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
Swiper.use([Pagination, Navigation, Autoplay]);

const certifications = new Swiper('.certification-slider', {
	loop: true,
	spaceBetween: 75,
	speed: 800,
	// autoplay: {
	// 	delay: 4000,
	// },
	navigation: {
		nextEl: '.certification-next',
		prevEl: '.certification-prev',
	},
	breakpoints: {
		200: {
			slidesPerView: 1,
			spaceBetween: 25
		},
		500: {
			slidesPerView: 2,
			spaceBetween: 25
		},
		800: {
			slidesPerView: 3,
		},
	}
});
